import { Stack } from "@mui/material";
import ThemeContext from "components/app/Context";
import KeyMetrics from "components/common/KeyMetrics/KeyMetrics";
import { useTranslate } from "hooks/useTranslate";
import { useContext, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { fetchUserViewSnapshot } from "../UserView/UserView.slice";
import { fetchPropertySnapshot } from "./IndividualProperty.slice";
import "./SnapShot.scss";

const SnapShot = (props: any) => {
  const { label = "" } = props;
  const dispatch = useAppDispatch();
  const { isMobileScreen } = useContext(ThemeContext);
  const { propertySnapshot } = useAppSelector((state) => state.individualProperty);
  const userSnapshot: any = useAppSelector((state) => state.userView.userSnapshot);
  let planSnapshot = propertySnapshot?.PROPERTY_PLAN_SNAPSHOT ? propertySnapshot?.PROPERTY_PLAN_SNAPSHOT[0] : {};
  let actionSnapshot = propertySnapshot?.PROPERTY_CARDS_SNAPSHOT ? propertySnapshot?.PROPERTY_CARDS_SNAPSHOT[0] : {};
  const translate = useTranslate();

  const userPlanSnapshot = userSnapshot?.USER_PROPERTY_PLAN_SNAPSHOT
    ? userSnapshot?.USER_PROPERTY_PLAN_SNAPSHOT[0]
    : {};
  const userActionSnapshot = userSnapshot?.USER_PROPERTY_CARDS_SNAPSHOT
    ? userSnapshot?.USER_PROPERTY_CARDS_SNAPSHOT[0]
    : {};

  if (props?.isUser) {
    planSnapshot = userPlanSnapshot;
    actionSnapshot = userActionSnapshot;
  }

  useEffect(() => {
    if (props?.isUser) {
      dispatch(fetchUserViewSnapshot({ hltId: props?.hltId, innCode: props?.innCode }));
    } else {
      dispatch(fetchPropertySnapshot({ inncode: props?.id }));
    }
  }, [props?.innCode]);

  const plansSnapShotData = [
    {
      isPrimary: true,
      title: translate("common.completed"),
      subTitle: translate("common.pastDays"),
      data: planSnapshot?.completedLast90Days
    },
    {
      subTitle: translate("common.totalActive"),
      data: planSnapshot?.active,
      showBorder: true
    },
    {
      subTitle: translate("common.overdue"),
      data: planSnapshot?.overdue
    }
  ];
  const actionsSnapData = [
    {
      isPrimary: true,
      title: translate("common.completed"),
      subTitle: translate("common.pastDays"),
      data: actionSnapshot?.completedLast90Days
    },
    { subTitle: translate("common.totalActive"), data: actionSnapshot?.active, showBorder: true },
    {
      subTitle: translate("common.overdue"),
      data: actionSnapshot?.overdue
    }
  ];

  return (
    <>
      <Stack
        direction={isMobileScreen ? "column" : "row"}
        marginTop={"32px"}
        spacing={2}
        className="snapshot-component"
      >
        <KeyMetrics label={translate("dashboard.PlanLabel")} keyMetricsData={plansSnapShotData} />
        <KeyMetrics label={translate("dashboard.actionsLabel")} keyMetricsData={actionsSnapData} />
      </Stack>
    </>
  );
};

export default SnapShot;
